import { Box, IconButton, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { MutatingDots } from 'react-loader-spinner';
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { API_BASE } from "../../api";

const RedirectSurvey = (props) => {
  const data = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const columns = [
    {
      field: "id",
      headerName: "ID",
      renderCell: (row) => <Link to={`/survey-detail/${row.id}`} >{row.id}</Link>
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "phone",
      headerName: "Phone Number",
      flex: 1,
    },
    {
      field: "age",
      headerName: "Age",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },

    {
      field: "income",
      headerName: "Income",
      flex: 1,
    },
    {
      field: "business",
      headerName: "Business",
      flex: 1,
    },
  ];

  const [surveyData, setSurveyData] = useState([]);
  const [researcherName, setResearcherName] = useState('');
  const [loading, setLoading] = useState(true);
  const userId = data.userId.split('&')[0];
  const stateId = data.userId.split('&')[1];
  const districtId = data.userId.split('&')[2];
  const acNo = data.userId.split('&')[3];
  const pcNo = data.userId.split('&')[4];
  const campId = data.userId.split('&')[5];
  const date = data.userId.split('&').map(part => decodeURIComponent(part))[6];
  const dateQueryParam = date === "null" ? null : date;
  const encodedDate = encodeURIComponent(dateQueryParam);
  const navigate = useNavigate();
  useEffect(() => {
    try {
      fetch(`${API_BASE}/surveys?userId=${userId}&state_id=${stateId}&districtId=${districtId}&acNo=${acNo}&pcNo=${pcNo}&campId=${campId}&role=${props.role}&date=${encodedDate}`).then((res) => {
        return res.json()
      }).then(data => {
        setSurveyData(data.result);
        setResearcherName(data.researcherName || 'Unknown Researcher');
        setLoading(false);
      })
    }
    catch (e) {
      console.log(e)
    };
  }, []);
  return (
    <Box m="20px">
      <Header title={`Surveys by ${researcherName} (${surveyData.length})`} subtitle="Note: The above total is only for the selected filter(s)" />
      <button style={{padding: '0px 11px',borderRadius: '10px',backgroundColor: '#7e1d1d'}} onClick={() => navigate(-1)}><ArrowBackIcon/></button>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        {(!loading && surveyData) ? (
          <DataGrid checkboxSelection rows={surveyData} columns={columns} />) :
          (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}> <MutatingDots
            height="100"
            width="100"
            color="#3E4396"
            secondaryColor='#3E4396'
            radius='12.5'
            ariaLabel="mutating-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            style={{
              left: "30%",
              backgroundColor: "#f0f0f0",
              borderRadius: "50%",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
            }}
          /></div>)}
      </Box>
    </Box>
  );
};

export default RedirectSurvey;
